<template>
    <div class="fullPage">
        <img src="../../assets/image/banner/banner3.jpg" alt class="fullWidth"/>
        <div class="main-center main-top">
            <!--并单查询-->
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('combineBill.voyageCombineSearch')" class="searchComposite">
                    <div>
                        <div class="flex flex-space-around">
                            <!--船名-->
                            <div class="inputName">
                                <el-col :span="7">
                                    <span class="inputName-title">
                                        {{$t('combineBill.VVL')}}
                                    </span>
                                    <el-input v-model="search.vesselCode"
                                              :placeholder="$t('common.pleaseEnter')"
                                              clearable
                                              @input="formatUpper('search','vesselCode',search.vesselCode)"/>
                                </el-col>
                                <el-col :span="7">
                                    <el-input v-model="search.voyageNo" :placeholder="$t('common.pleaseEnter')"
                                              clearable
                                              @input="formatUpper('search','voyageNo',search.voyageNo)"/>
                                </el-col>
                                <el-col :span="5">
                                    <el-input v-model="search.voyageLeg" :placeholder="$t('common.pleaseEnter')"
                                              clearable
                                              @input="formatUpper('search','voyageLeg',search.voyageLeg)"/>
                                </el-col>
                                <!--VVL弹框-->
                                <el-popover ref="popover" placement="bottom" width="700" trigger="click"
                                            @hide="boatListShow=false">
                                    <div>
                                        <div class="flex flex-space-between">
                                            <!--船名查询条件-->
                                            <div class="inputName-left boatBox">
                                                <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.vessel')}}
                                                        </span>
                                                </div>
                                                <el-input v-model="search.vesselCode"
                                                          :placeholder="$t('common.pleaseEnter')"
                                                          clearable
                                                          @input="formatUpper('search','vesselCode',search.vesselCode)"
                                                          @focus="showVesselList">
                                                    <img src="../../assets/image/icon/classification.svg"
                                                         slot="suffix"
                                                         @click="showVesselList">
                                                </el-input>
                                                <!--船名列表-->
                                                <div class="boatBox-list-box" v-show="boatListShow">
                                                    <div class="boatBox-top flex">
                                                        <div class="left">
                                                            {{$t('booking.popover.vesselCode')}}
                                                        </div>
                                                        <div class="right">
                                                            {{$t('booking.popover.vesselNameCn')}}
                                                        </div>
                                                    </div>
                                                    <ul>
                                                        <li v-for="(i,j) in boatList" class="flex"
                                                            :key="j"
                                                            @click="checkBoatData(i)">
                                                            <div class="left">{{i.vesselCode}}</div>
                                                            <div class="right">{{i.vesselNameCn}}</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <!--船中文名查询条件-->
                                            <div class="inputName-left">
                                                <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.vesselNameCn')}}
                                                        </span>
                                                </div>
                                                <el-input v-model="search.vesselName"
                                                          :placeholder="$t('common.pleaseEnter')"
                                                          clearable
                                                          @input="formatUpper('search','vesselName',search.vesselName)"/>
                                            </div>
                                            <!--VVL查询按钮-->
                                            <el-button class="popoverInner" size="small" icon="el-icon-search"
                                                       @click="vvlSearch">
                                                {{findButton}}
                                            </el-button>
                                        </div>
                                        <div class="flex flex-space-between">
                                            <!--航次查询条件-->
                                            <div class="inputName-left">
                                                <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.voyageNo')}}
                                                        </span>
                                                </div>
                                                <el-input v-model="search.voyageNo"
                                                          :placeholder="$t('common.pleaseEnter')"
                                                          clearable
                                                          @input="formatUpper('search','voyageNo',search.voyageNo)"/>
                                            </div>
                                            <!--航段查询条件-->
                                            <div class="inputName-left">
                                                <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.voyageLeg')}}
                                                        </span>
                                                    <span style="visibility:hidden"></span>
                                                </div>
                                                <el-input v-model="search.voyageLeg"
                                                          :placeholder="$t('common.pleaseEnter')"
                                                          clearable
                                                          @input="formatUpper('search','voyageLeg',search.voyageLeg)"/>
                                            </div>
                                            <!--VVL关闭按钮-->
                                            <el-button size="small" class="popoverInner"
                                                       icon="el-icon-warning-outline"
                                                       @click="closePopoverView">
                                                {{closeButton}}
                                            </el-button>
                                        </div>
                                        <!--船名数据查询表格-->
                                        <el-table :data="popData" style="width:100%;margin-top:5px"
                                                  max-height="300" highlight-current-row
                                                  :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                                                  :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                                                  :empty-text="$t('common.noData')"
                                                  @row-dblclick="popRowDblclick"
                                                  @row-click="popRowClick">
                                            <!--序号-->
                                            <el-table-column min-width="60" type="index"
                                                             :label="$t('booking.popover.no')"
                                                             align="center"></el-table-column>
                                            <!--船舶代码-->
                                            <el-table-column min-width="110" prop="vesselCode"
                                                             :label="$t('booking.popover.vesselCode')"
                                                             align="center"></el-table-column>
                                            <!--船名-->
                                            <el-table-column min-width="190" prop="vesselName"
                                                             :label="$t('booking.popover.vessel')"
                                                             align="center"></el-table-column>
                                            <!--船中文名-->
                                            <el-table-column min-width="140" prop="vesselNameCn"
                                                             :label="$t('booking.popover.vesselNameCN')"
                                                             align="center"></el-table-column>
                                            <!--航次-->
                                            <el-table-column min-width="100" prop="voyageNo"
                                                             :label="$t('booking.popover.voyageNo')"
                                                             align="center"></el-table-column>
                                            <!--航段-->
                                            <el-table-column min-width="110" prop="voyageLeg"
                                                             :label="$t('booking.popover.voyageLeg')"
                                                             align="center"></el-table-column>
                                        </el-table>
                                        <div class="flex flex-space-between">
                                            <div class="topMargin flex1">
                                                {{getTotalDisplay}}
                                            </div>
                                            <!--VVL确认按钮-->
                                            <el-button class="topMargin" type="primary"
                                                       @click="popConfirm">
                                                {{confirmButton}}
                                            </el-button>
                                            <!--VVL pagination分页条-->
                                            <div class="pagination flex1">
                                                <el-pagination small layout="sizes,pager"
                                                               :page-size="popPageSize" :page-sizes="[5, 10]"
                                                               :total="popTotal"
                                                               :pager-count="popPageCount"
                                                               :current-page="popPageNum"
                                                               @size-change="popHandleSizeChange"
                                                               @current-change="popHandleCurrentChange"
                                                               max-height="600"></el-pagination>
                                            </div>
                                        </div>
                                    </div>
                                    <img slot="reference" style="cursor:pointer" class="voyageIcon"
                                         src="../../assets/image/voyage.png"/>
                                </el-popover>
                            </div>
                            <!--提单号-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t("combineBill.blNo")}}
                                </span>
                                <el-input v-model="search.blNo"
                                          :placeholder="$t('common.pleaseEnter')"
                                          @input="formatUpper('search','blNo',search.blNo)"/>
                            </div>
                            <!--订舱号-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t("combineBill.bkNo")}}
                                </span>
                                <el-input v-model="search.bkNo"
                                          :placeholder="$t('common.pleaseEnter')"
                                          @input="formatUpper('search','bkNo',search.bkNo)"/>
                            </div>
                            <!--卸货港-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("combineBill.pod")}}</span>
                                <el-select v-model="search.pod"
                                           :placeholder="$t('common.pleaseSelect')"
                                           clearable filterable default-first-option
                                           @focus="portFocus">
                                    <el-option v-for="item in portOptions"
                                               :key="item.portCode" :label="item.portCode" :value="item.portCode">
                                        <span style="float: left">{{item.portCode}}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="flex flex-space-around topMargin">
                            <!--目的港-->
                            <div class="inputName">
                                <span class="inputName-title">{{$t("combineBill.del")}}</span>
                                <el-select v-model="search.del"
                                           :placeholder="$t('common.pleaseSelect')"
                                           clearable filterable default-first-option
                                           @focus="portFocus">
                                    <el-option v-for="item in portOptions"
                                               :key="item.portCode" :label="item.portCode" :value="item.portCode">
                                        <span style="float: left">{{item.portCode}}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="inputName">
                                <span class="inputName-title"></span>
                            </div>
                            <div class="inputName">
                                <span class="inputName-title"></span>
                            </div>
                            <div class="searchBtn">
                                <el-button type="primary" icon="el-icon-search"
                                           @click="combineSearchAction">
                                    {{searchButton}}
                                </el-button>
                                <el-button icon="el-icon-refresh"
                                           @click="resetAction">
                                    {{resetButton}}
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <!--查询结果-->
            <div class="searchList">
                <div class="cardBox">
                    <el-row :gutter="20">
                        <!--舱单信息表格-->
                        <el-col style="width: 50%;">
                            <div class="cardTitle flex flex-align">
                                <img src="../../assets/image/icon/order2.svg" alt="">
                                <span>{{$t('combineBill.billInfo')}}</span>
                            </div>
                            <div class="cardBody">
                                <div class="mainTable">
                                    <el-table :data="tableBillInfo" ref="tableBillInfo"
                                              style="width:100%;margin-top:5px"
                                              height="250" max-height="300" highlight-current-row
                                              :header-cell-style="{background:'#E9E9E9',height:'30px',padding:0}"
                                              :row-style="{height:'25px'}" :cell-style="{padding:'0px'}"
                                              :empty-text="$t('common.noData')"
                                              :row-class-name="rowClassName"
                                              @row-click="tableBillInfoRowClick" @cell-dblclick="editData">
                                        <!--序号-->
                                        <el-table-column min-width="50" show-overflow-tooltip type="index"
                                                         :label="this.$t('combineBill.no')" align="center"/>
                                        <!--提单号-->
                                        <el-table-column min-width="220" show-overflow-tooltip prop="blNo" :label="this.$t('combineBill.blNo')"
                                                         align="center">
                                            <template slot-scope="scope">
                                                <el-input v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                                          :ref="scope.column.property"
                                                          v-model="scope.row.blNo" size="small"
                                                          @blur="alterData(scope.row,scope.column)">
                                                    <el-button style="padding-right:10px" slot="suffix"
                                                               icon="el-icon-check" type="text" size="mini"
                                                               @click="alterData(scope.row,scope.column)"/>
                                                </el-input>
                                                <span v-else>{{ scope.row.blNo }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--订舱号-->
                                        <el-table-column min-width="220" show-overflow-tooltip prop="bkNo" :label="this.$t('combineBill.bkNo')"
                                                         align="center">
                                            <template slot-scope="scope">
                                                <el-input v-if="scope.row[scope.column.property + scope.row.index + 'isShow']"
                                                          :ref="scope.column.property"
                                                          v-model="scope.row.bkNo" size="small"
                                                          @blur="alterData(scope.row,scope.column)">
                                                    <el-button style="padding-right:10px" slot="suffix"
                                                               icon="el-icon-check" type="text" size="mini"
                                                               @click="alterData(scope.row,scope.column)"/>
                                                </el-input>
                                                <span v-else>{{ scope.row.bkNo }}</span>
                                            </template>
                                        </el-table-column>
                                        <!--装货港-->
                                        <el-table-column min-width="100" show-overflow-tooltip prop="pol" :label="this.$t('combineBill.pol')"
                                                         align="center"/>
                                        <!--卸货港-->
                                        <el-table-column min-width="150" show-overflow-tooltip prop="pod" :label="this.$t('combineBill.pod')"
                                                         align="center"/>
                                        <!--收货人-->
                                        <el-table-column min-width="400" show-overflow-tooltip prop="consigneeName"
                                                         :label="this.$t('combineBill.consigneeName')"
                                                         align="center"/>
                                        <!--发货人-->
                                        <el-table-column min-width="400" show-overflow-tooltip prop="shipperName"
                                                         :label="this.$t('combineBill.shipperName')"
                                                         align="center"/>
                                        <!--通知人-->
                                        <el-table-column min-width="400" show-overflow-tooltip prop="notify1Name"
                                                         :label="this.$t('combineBill.notify1Name')"
                                                         align="center"/>
                                        <!--品名名称-->
                                        <el-table-column min-width="200" show-overflow-tooltip prop="cargoCommodityName"
                                                         :label="this.$t('combineBill.cargoCommodityName')"
                                                         align="center"/>
                                        <!--唛头-->
                                        <el-table-column min-width="180" show-overflow-tooltip prop="cargoShippingMark"
                                                         :label="this.$t('combineBill.cargoShippingMark')"
                                                         align="center"/>
                                        <!--制单件数-->
                                        <el-table-column min-width="160" show-overflow-tooltip prop="cargoQuantity"
                                                         :label="this.$t('combineBill.cargoQuantity')"
                                                         align="center"/>
                                        <!--制单重量-->
                                        <el-table-column min-width="150" show-overflow-tooltip prop="cargoGrossWeight"
                                                         :label="this.$t('combineBill.cargoGrossWeight')"
                                                         align="center"/>
                                        <!--制单尺寸-->
                                        <el-table-column min-width="150" show-overflow-tooltip prop="cargoSize"
                                                         :label="this.$t('combineBill.cargoSize')"
                                                         align="center"/>
                                        <!--运输条款-->
                                        <el-table-column min-width="150" show-overflow-tooltip
                                                         prop="transportationTerms" :label="this.$t('combineBill.transportationTerms')"
                                                         align="center"/>
                                    </el-table>
                                </div>
                                <div>
                                    <el-button @click="SetBlNoForMBLAction" type="success" size="mini"
                                               icon="el-icon-star-on" :disabled="!getSetBlNoForMBLButtonEnabled">
                                        {{setBlNoForMBLButton}}
                                    </el-button>
                                    <el-button @click="cancelCombineAction" type="warning" size="mini"
                                               icon="el-icon-refresh-right" :disabled="!getcancelCombineButtonEnabled">
                                        {{cancelCombineButton}}
                                    </el-button>
                                </div>
                            </div>
                        </el-col>
                        <!--主单箱信息-->
                        <el-col style="width: 50%;">
                            <div class="cardTitle flex flex-align">
                                <img src="../../assets/image/icon/order12.svg" alt="">
                                <span>{{$t('combineBill.masterPreContainerInfo')}}</span>
                            </div>
                            <div class="cardBody">
                                <div class="mainTable">
                                    <el-table :data="tableMasterPreContainerBillInfo" ref="tableMasterPreContainerBillInfo"
                                              style="width:100%;margin-top:5px"
                                              height="250" max-height="300" highlight-current-row
                                              :header-cell-style="{background:'#E9E9E9',height:'30px',padding:0}"
                                              :row-style="{height:'25px'}" :cell-style="{padding:'0px'}"
                                              :empty-text="$t('common.noData')"
                                              :row-class-name="rowClassName">
                                        <!--序号-->
                                        <el-table-column min-width="60" show-overflow-tooltip type="index"
                                                         :label="this.$t('combineBill.no')" align="center"/>
                                        <!--箱型代码-->
                                        <el-table-column min-width="80" show-overflow-tooltip prop="containerType"
                                                         :label="$t('combineBill.containerType')"
                                                         align="center"/>
                                        <!--数量-->
                                        <el-table-column min-width="50" show-overflow-tooltip prop="quantity" :label="$t('combineBill.quantity')"
                                                         align="center"/>
                                        <!--货类-->
                                        <el-table-column min-width="100" show-overflow-tooltip prop="cargoTypeCode"
                                                         :label="$t('combineBill.cargoTypeCode')"
                                                         align="center">
                                            <template slot-scope="scope">
                                                <span>{{getCargoTypeName(scope.row.cargoTypeCode)}}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="flex flex-space-between">
<!--                                    <el-col :span="14">-->
<!--                                        <el-input-->
<!--                                                placeholder="0" size="mini"-->
<!--                                                v-model="masterTotal.quantity"-->
<!--                                                :disabled="true">-->
<!--                                            <template slot="prepend">件/重/尺（订舱/实际）</template>-->
<!--                                        </el-input>-->
<!--                                    </el-col>-->
<!--                                    <el-col :span="6">-->
<!--                                        <el-input-->
<!--                                                placeholder="0" size="mini"-->
<!--                                                v-model="masterTotal.grossWeight"-->
<!--                                                :disabled="true">-->
<!--                                        </el-input>-->
<!--                                    </el-col>-->
<!--                                    <el-col :span="6">-->
<!--                                        <el-input-->
<!--                                                placeholder="0" size="mini"-->
<!--                                                v-model="masterTotal.cargoSize"-->
<!--                                                :disabled="true">-->
<!--                                        </el-input>-->
<!--                                    </el-col>-->
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <!--分单信息表格-->
                        <el-col style="width: 50%;">
                            <div class="cardTitle flex flex-align">
                                <img src="../../assets/image/icon/order2.svg" alt="">
                                <span>{{$t('combineBill.hblInfo')}}</span>
                            </div>
                            <div class="cardBody">
                                <div class="mainTable">
                                    <el-table :data="tableHBLInfo" ref="tableHBLInfo" style="width:100%;margin-top:5px"
                                              height="250" max-height="300" highlight-current-row
                                              :header-cell-style="{background:'#E9E9E9',height:'30px',padding:0}"
                                              :row-style="{height:'25px'}" :cell-style="{padding:'0px'}"
                                              :empty-text="$t('common.noData')"
                                              :row-class-name="rowClassName"
                                              @row-click="tableHBLRowClick"
                                              @selection-change="tableHBLSelectionChange">
                                        <!--多选-->
                                        <el-table-column type="selection" width="42"/>
                                        <!--序号-->
                                        <el-table-column min-width="80" show-overflow-tooltip type="index"
                                                         :label="this.$t('combineBill.no')" align="center"/>
                                        <!--提单号-->
                                        <el-table-column min-width="180" show-overflow-tooltip prop="blNo" :label="this.$t('combineBill.blNo')"
                                                         align="center"/>
                                        <!--订舱号-->
                                        <el-table-column min-width="180" show-overflow-tooltip prop="bkNo" :label="this.$t('combineBill.bkNo')"
                                                         align="center"/>
                                        <!--装货港-->
                                        <el-table-column min-width="80" show-overflow-tooltip prop="pol" :label="this.$t('combineBill.pol')"
                                                         align="center"/>
                                        <!--卸货港-->
                                        <el-table-column min-width="80" show-overflow-tooltip prop="pod" :label="this.$t('combineBill.pod')"
                                        align="center"/>
                                        <!--收货人-->
                                        <el-table-column min-width="400" show-overflow-tooltip prop="consigneeName"
                                                         :label="this.$t('combineBill.consigneeName')"
                                                         align="center"/>
                                        <!--发货人-->
                                        <el-table-column min-width="400" show-overflow-tooltip prop="shipperName"
                                                         :label="this.$t('combineBill.shipperName')"
                                                         align="center"/>
                                        <!--通知人-->
                                        <el-table-column min-width="400" show-overflow-tooltip prop="notify1Name"
                                                         :label="this.$t('combineBill.notify1Name')"
                                                         align="center"/>
                                        <!--品名名称-->
                                        <el-table-column min-width="200" show-overflow-tooltip prop="cargoCommodityName"
                                                         :label="this.$t('combineBill.cargoCommodityName')"
                                                         align="center"/>
                                        <!--唛头-->
                                        <el-table-column min-width="220" show-overflow-tooltip prop="cargoShippingMark"
                                                         :label="this.$t('combineBill.cargoShippingMark')"
                                                         align="center"/>
                                        <!--制单件数-->
                                        <el-table-column min-width="160" show-overflow-tooltip prop="cargoQuantity"
                                                         :label="this.$t('combineBill.cargoQuantity')"
                                                         align="center"/>
                                        <!--制单重量-->
                                        <el-table-column min-width="150" show-overflow-tooltip prop="cargoGrossWeight"
                                                         :label="this.$t('combineBill.cargoGrossWeight')"
                                                         align="center"/>
                                        <!--制单尺寸-->
                                        <el-table-column min-width="150" show-overflow-tooltip prop="cargoSize"
                                                         :label="this.$t('combineBill.cargoSize')"
                                                         align="center"/>
                                        <!--运输条款-->
                                        <el-table-column min-width="150" show-overflow-tooltip
                                                         prop="transportationTerms" :label="this.$t('combineBill.transportationTerms')"
                                                         align="center"/>
                                    </el-table>
                                </div>
                                <div>
                                    <el-button @click="queryHBLByVoyageAction" type="primary" size="mini"
                                               icon="el-icon-search" :disabled="!getHBLQueryButtonEnabled">
                                        {{$t('combineBill.queryHBLByVoyageButton')}}
                                    </el-button>
                                    <el-button @click="removeHBLAction" type="info" size="mini"
                                               icon="el-icon-remove" :disabled="!getRemoveHBLButtonEnabled">
                                        {{$t('combineBill.removeHBLButton')}}
                                    </el-button>
                                </div>
                            </div>
                        </el-col>
                        <!--分单箱信息-->
                        <el-col style="width: 50%;">
                            <div class="cardTitle flex flex-align">
                                <img src="../../assets/image/icon/order12.svg" alt="">
                                <span>{{$t('combineBill.hBLPreContainerInfo')}}</span>
                            </div>
                            <div class="cardBody">
                                <div class="mainTable">
                                    <el-table :data="tableHBLPreContainerBillInfo" ref="tableHBLPreContainerBillInfo"
                                              style="width:100%;margin-top:5px"
                                              height="250" max-height="300" highlight-current-row
                                              :header-cell-style="{background:'#E9E9E9',height:'30px',padding:0}"
                                              :row-style="{height:'25px'}" :cell-style="{padding:'0px'}"
                                              :empty-text="$t('common.noData')"
                                              :row-class-name="rowClassName">
                                        <!--序号-->
                                        <el-table-column min-width="60" show-overflow-tooltip type="index"
                                                         :label="this.$t('combineBill.no')" align="center"/>
                                        <!--箱型代码-->
                                        <el-table-column min-width="80" show-overflow-tooltip prop="containerType"
                                                         :label="$t('combineBill.containerType')"
                                                         align="center"/>
                                        <!--数量-->
                                        <el-table-column min-width="50" show-overflow-tooltip prop="quantity" :label="$t('combineBill.quantity')"
                                                         align="center"/>
                                        <!--货类-->
                                        <el-table-column min-width="100" show-overflow-tooltip prop="cargoTypeCode"
                                                         :label="$t('combineBill.cargoTypeCode')"
                                                         align="center">
                                            <template slot-scope="scope">
                                                <span>{{getCargoTypeName(scope.row.cargoTypeCode)}}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>

        <!--分单查询弹出框-->
        <el-dialog
                :visible.sync="HBLInfoDialogVisible"
                width="40%" top="10%">
            <div slot="title" class="flex flex-align">
                <img src="../../assets/image/icon/order-ico5.svg" alt="">
                {{$t('combineBill.queryHBLByVoyageButton')}}
            </div>
            <div>
                <div class="flex flex-space-between">
                    <!--提单号查询条件-->
                    <div class="inputName-left boatBox">
                        <div class="inputName-title-left">
                            <span>{{$t('combineBill.blNo')}}</span>
                        </div>
                        <el-input v-model="HBLSearch.blNo"
                                  :placeholder="$t('common.pleaseEnter')"
                                  clearable
                                  @input="formatUpper('HBLSearch','blNo',search.blNo)">
                        </el-input>
                    </div>
                    <!--分单查询按钮-->
                    <el-button class="popoverInner" size="small" icon="el-icon-search"
                               @click="popHBLSearchClick">
                        {{findButton}}
                    </el-button>
                </div>
                <!--分单数据表格-->
                <el-table :data="popTableSearchHBLInfo" style="width:100%;margin-top:5px"
                          height="350" max-height="350" highlight-current-row
                          :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                          :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                          :empty-text="$t('common.noData')" class="popTableSearchHBLInfo"
                          @selection-change="popHBLTableSelectionChange">
                    <!--多选-->
                    <el-table-column type="selection" width="80"/>
                    <!--序号-->
                    <el-table-column min-width="60" type="index"
                                     :label="$t('combineBill.no')"
                                     align="center"></el-table-column>
                    <!--提单号-->
                    <el-table-column min-width="180" show-overflow-tooltip prop="blNo"
                                     :label="$t('combineBill.blNo')"
                                     align="center"></el-table-column>
                    <!--订舱号-->
                    <el-table-column min-width="180" show-overflow-tooltip prop="bkNo"
                                     :label="$t('combineBill.bkNo')"
                                     align="center"></el-table-column>
                    <!--装货港-->
                    <el-table-column min-width="140" show-overflow-tooltip prop="pol"
                                     :label="$t('combineBill.pol')"
                                     align="center"></el-table-column>
                    <!--卸货港-->
                    <el-table-column min-width="100" show-overflow-tooltip prop="pod"
                                     :label="$t('combineBill.pod')"
                                     align="center"></el-table-column>
                    <!--收货人-->
                    <el-table-column min-width="150" show-overflow-tooltip prop="consigneeName"
                                     :label="$t('combineBill.consigneeName')"
                                     align="center"></el-table-column>
                    <!--发货人-->
                    <el-table-column min-width="150" show-overflow-tooltip prop="shipperName"
                                     :label="$t('combineBill.shipperName')"
                                     align="center"></el-table-column>
                    <!--通知人-->
                    <el-table-column min-width="110" show-overflow-tooltip prop="notify1Name"
                                     :label="$t('combineBill.notify1Name')"
                                     align="center"></el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="popNewHBLClick(true)">{{addButton2}}</el-button>
                    <el-button type="primary" @click="popNewHBLClick(false)" :disabled="!getPopAppendHBLButtonEnabled">{{appendButton}}</el-button>
                    <el-button @click="popCancelClick">{{cancelButton2}}</el-button>
                  </span>
            </div>
        </el-dialog>

        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "booking",
        computed: {
            searchButton() {//查询按钮
                return this.$t("common.searchButton");
            },
            resetButton() {//重置按钮
                return this.$t("common.resetButton");
            },
            getTotalDisplay() {
                return this.$t("common.total").replace("?", this.popTotal);
            },
            findButton() {//搜索按钮
                return this.$t("common.findButton");
            },
            closeButton() {//关闭按钮
                return this.$t("common.closeButton");
            },
            confirmButton() {//确认按钮
                return this.$t("common.confirmButton");
            },
            addButton2() {//新增按钮
                return this.$t("common.addButton2");
            },
            appendButton() {//新增按钮
                return this.$t("common.appendButton");
            },
            cancelCombineButton() {//取消并单
                return this.$t("combineBill.cancelCombineButton");
            },
            cancelButton2() {//取消
                return this.$t("common.cancelButton2");
            },
            setBlNoForMBLButton() {//设置当前提单为主单
                return this.$t("combineBill.setBlNoForMBLButton");
            },
            getSetBlNoForMBLButtonEnabled() {
                return this.tableHBLInfo != null && this.tableHBLInfo.length >= 2;
            },
            getcancelCombineButtonEnabled() {
                return this.tableBillInfo != null
                    && this.tableBillInfo.length > 0
                    && this.tableBillInfoSelection.length > 0;
            },
            getHBLQueryButtonEnabled() {
                return true;
            },
            getRemoveHBLButtonEnabled() {
                return this.tableHBLInfo.length > 0;
            },
            getPopAppendHBLButtonEnabled() {
                return this.addHBLBillInfoList != null
                    && this.addHBLBillInfoList.length > 0;
            }
        },
        components: {},
        data() {
            return {
                isClick: false,             //控制按钮是否重复点击
                boatListShow: false,        //控制船舶查询弹框是否显示
                HBLInfoDialogVisible: false,//控制分单查询弹框是否显示
                cargoTypeOptions: [],
                containerTypeOptions: [],
                //并单查询参数
                search: {
                    vesselCode: "",         //船舶代码
                    voyageNo: "",           //航次
                    voyageLeg: "",          //航段
                    blNo: "",               //提单号
                    bkNo: "",               //提单号
                    pod: "",                //卸货港
                    del: "",                //目的港
                    vesselName: ""          //船舶名称
                },
                //并单主单箱信息件重尺合计数据
                masterTotal: {
                    quantity: 0,
                    grossWeight: 0,
                    cargoSize: 0
                },
                //分单查询参数
                HBLSearch: {
                    vesselCode: "",         //船舶代码
                    voyageNo: "",           //航次
                    voyageLeg: "",          //航段
                    blNo: "",               //提单号
                    consigneeCode: "",      //发货人
                    bookingHeadId: ""       //分单ID
                },
                //表格数据
                tableBillInfo: [],          //主单信息
                tableMasterPreContainerBillInfo: [],//主单箱信息
                tableHBLInfo: [],           //分单信息
                tableHBLPreContainerBillInfo: [], //分单箱信息
                addHBLBillInfoList: [],     //新增分单信息
                portOptions: [],
                popData: [],
                popPageCount: 5,
                popPageNum: 1,
                popPageSize: 5,
                popTotal: 0,
                popTableSearchHBLInfo: [],  //分单查询弹框表格数据
                boatList: [],               //船舶数据
                //表格选中当前行数据
                popVVLTableSelection: [],   //vvl弹框中鼠标点击选中的值
                popHBLTableSelection: [],   //分单查询弹框中选中的分单
                tableBillInfoSelection: [], //主单信息表格中选中的当前行
                tableHBLInfoSelection: [],  //分单信息表格中选中的当前行
                //表格批量勾选数据
                popTableHBLInfoChecked: [], //分单查询弹框中批量勾选的分单记录
                tableHBLInfoChecked: [],    //存放分单表格中批量勾选的分单记录
                randomKey: Math.random()
            };
        },
        methods: {
            //保留2位小数
            toDecimal2(x) {
                var f = parseFloat(x);
                if (isNaN(f)) {
                    return false;
                }
                var ff = Math.round(x*100)/100;
                var s = ff.toString();
                var rs = s.indexOf('.');
                if (rs < 0) {
                    rs = s.length;
                    s += '.';
                }
                while (s.length <= rs + 2) {
                    s += '0';
                }
                return s;
            },
            /**
             * 表格编辑事件
             */
            editData(row, column) {
                // row[column.property + row.index + "isShow"] = true;
                // //refreshTable是table数据改动时，刷新table的
                // this.refreshTable();
                // this.$nextTick(() => {
                //     this.$refs[column.property] && this.$refs[column.property].focus()
                // })
            },
            alterData(row, column) {
                row[column.property + row.index + "isShow"] = false;
                this.refreshTable()
            },
            refreshTable() {
                this.randomKey = Math.random()
            },

            /**
             * 获取主单箱信息中件重尺合计
             */
            calculateMatserTotal() {
                if (this.tableMasterPreContainerBillInfo != null && this.tableMasterPreContainerBillInfo.length > 0) {
                    let quantity = 0;
                    let grossWeight = 0;
                    let cargoSize = 0;
                    this.tableMasterPreContainerBillInfo.forEach((container) => {
                        //统计件数
                        if (container.quantity !== "") {
                            quantity = quantity + container.quantity
                        }
                        //统计毛重
                        if (container.weight !== "") {
                            grossWeight = grossWeight + container.weight
                        }
                        //统计尺寸
                        if (container.cntrSize !== "") {
                            cargoSize = cargoSize + container.cntrSize
                        }
                    });
                    this.masterTotal.quantity = this.toDecimal2(quantity);
                    this.masterTotal.grossWeight = this.toDecimal2(grossWeight);
                    this.masterTotal.cargoSize = this.toDecimal2(cargoSize);
                }else{
                    this.masterTotal.quantity = this.toDecimal2(0);
                    this.masterTotal.grossWeight = this.toDecimal2(0);
                    this.masterTotal.cargoSize = this.toDecimal2(0);
                }
            },
            rowClassName({row, rowIndex}) {
                //把每一行的索引放进row
                row.index = rowIndex;
            },
            /**
             * 分单查询表格批量勾选事件
             */
            popHBLTableSelectionChange(array) {
                this.popTableHBLInfoChecked = array;
            },
            /**
             * 分单表格批量勾选事件
             */
            tableHBLSelectionChange(array) {
                this.tableHBLInfoChecked = array;
            },

            /************************************ 按钮点击事件 ***********************************
             * 并单查询、重置
             */
            combineSearchAction() {
                if (this.isClick) {
                    return;
                }
                this.isClick = true;

                //船名和航次为必选
                if (this.search.vesselCode === "" || this.search.voyageNo === "" || this.search.voyageLeg === "") {
                    this.showMessage(false, this.$t('message.pleaseEnterqueryConditions'), "warning");
                    this.isClick = false;
                    return
                }

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),             // 加载动画的文字
                    spinner: 'el-icon-loading',                     // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    target: document.querySelector(".searchList")   // 设置加载动画区域
                });
                let that = this;

                //调用后端并单查询API
                this.axios({
                    method: 'post',
                    url: '/api/spliteCombine/getCombineBillList',
                    data: {
                        vesselCode: this.search.vesselCode,
                        voyageNo: this.search.voyageNo,
                        voyageLeg: this.search.voyageLeg,
                        blNo: this.search.blNo,
                        bkNo: this.search.bkNo,
                        pod: this.pod,
                        del: this.del
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    //成功响应,关闭进度条
                    that.loadingtuo.close();
                    if (response.data.backCode === "200") {
                        // 清空主分单表格记录
                        this.tableBillInfo = [];
                        this.tableHBLInfo = [];
                        // 清空主/分单表格当前选中行
                        this.tableBillInfoSelection = [];
                        this.tableHBLInfoSelection = [];
                        // 清空新增分单记录集合
                        this.addHBLBillInfoList = [];

                        //赋值主单数据
                        let billInfo = JSON.parse(response.data.object);
                        this.tableBillInfo = billInfo;
                        //默认选中首行主单
                        if (this.tableBillInfo.length > 0) {
                            this.setTableCurrentRow(0, 0);
                        }
                        this.calculateMatserTotal();
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    //请求成功,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                }).catch(error => {
                    //请求失败,关闭进度条
                    that.loadingtuo.close();
                    //请求失败,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            resetAction() {//重置按钮点击
                this.search.vesselCode = "";
                this.search.voyageNo = "";
                this.search.voyageLeg = "";
                this.search.bkNo = "";
                this.search.blNo = "";
                this.search.carrier = "";
                this.search.shipperCode = "";
                this.search.vesselName = "";
            },
            /**
             * 航次分单信息查询
             */
            queryHBLByVoyageAction() {
                this.popTableSearchHBLInfo = [];
                //分单查询船名和航次为必选
                if (this.search.vesselCode === "" || this.search.voyageNo === "" || this.search.voyageLeg === "") {
                    this.showMessage(false, this.$t('message.pleaseEnterqueryConditions'), "warning");
                    return;
                }
                //设置分单查询船名航次参数
                this.HBLSearch.vesselCode = this.search.vesselCode;
                this.HBLSearch.voyageNo = this.search.voyageNo;
                this.HBLSearch.voyageLeg = this.search.voyageLeg;
                //打开查询弹框
                this.HBLInfoDialogVisible = true;
            },
            popHBLSearchClick() {
                if (this.isClick) {
                    return;
                }
                this.isClick = true;

                // 声明一个loading对象
                this.loadingtuo = this.$loading({
                    lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                    text: this.$t('message.searching'),             // 加载动画的文字
                    spinner: 'el-icon-loading',                     // 引入的loading图标
                    background: "rgb(0,0,0,0.1)",
                    target: document.querySelector(".popTableSearchHBLInfo")   // 设置加载动画区域
                });
                let that = this;

                // 获取已经添加到分单信息表格中的分单ID，在查询分单时需排除，避免重复添加
                let bookingHeadIds = '';
                this.tableHBLInfo.forEach((bill) => {
                    if (bookingHeadIds.length > 0) {
                        bookingHeadIds = bookingHeadIds + ',' + bill.bookingHeadId;
                    } else {
                        bookingHeadIds = bookingHeadIds + bill.bookingHeadId;
                    }
                });

                //调用后端分单查询API
                this.axios({
                    method: 'post',
                    url: '/api/spliteCombine/getAllCombineBillList',
                    data: {
                        vesselCode: this.HBLSearch.vesselCode,
                        voyageNo: this.HBLSearch.voyageNo,
                        voyageLeg: this.HBLSearch.voyageLeg,
                        blNo: this.HBLSearch.blNo,
                        consigneeCode: this.HBLSearch.consigneeCode,
                        bookingHeadId: bookingHeadIds
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        //清空分单批量选中记录
                        this.popTableHBLInfoChecked = [];
                        //赋值查询到的分单数据到表格中
                        let voyageHBLInfo = JSON.parse(response.data.object);
                        this.popTableSearchHBLInfo = voyageHBLInfo;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    //请求成功,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                    that.loadingtuo.close();
                }).catch(error => {
                    //请求失败,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                    that.loadingtuo.close();
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },

            /**
             * 设置当前提单为主单
             */
            SetBlNoForMBLAction() {
                if (this.isClick) {
                    return;
                }
                this.isClick = true;

                // 校验是否选中分单
                if (this.tableHBLInfoSelection == null || this.tableHBLInfoSelection.length <= 0) {
                    this.$alert(this.$t('message.chooseHBL2SetMBL'), this.$t("common.tips"), {
                        confirmButtonText: this.$t("common.okButton")
                    });
                    this.isClick = false;
                    return;
                }

                //调用后端API,传递选中作为主单的分单ID及全部分单
                this.axios({
                    method: 'post',
                    url: '/api/spliteCombine/setBlNoForMBL',
                    data: {
                        vwSpliteCombinList: JSON.stringify(this.tableHBLInfo),
                        bookingHeadMBLId: this.tableHBLInfoSelection[0].bookingHeadId
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale"),
                        'Content-type': "application/json;charset=utf-8"
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        // 清空新增分单列表
                        this.addHBLBillInfoList = [];
                        // 将新生成的主单设置到主单信息表格中
                        let billInfos = JSON.parse(response.data.object);
                        billInfos.forEach((billInfo)=>{
                            this.tableBillInfo.push(billInfo);
                        });
                        //默认选中最后一行
                        if (this.tableBillInfo.length > 0) {
                            this.setTableCurrentRow(0, this.tableBillInfo.length - 1);
                        }
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    //请求成功,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                }).catch(error => {
                    //请求失败,查询按钮设置为未点击状态,允许再次请求
                    this.isClick = false;
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 取消并单
             */
            cancelCombineAction() {
                if (this.isClick) {
                    return;
                }
                this.isClick = true;

                let bookingHeadMBLId = "";
                // 校验是否选中主单
                if (this.tableBillInfoSelection == null || this.tableHBLInfoSelection.length <= 0) {
                    this.$alert(this.$t('message.cancelCombineNote'), this.$t("common.tips"), {
                        confirmButtonText: this.$t("common.okButton")
                    });
                    this.isClick = false;
                    return;
                } else {
                    bookingHeadMBLId = this.tableBillInfoSelection[0].bookingHeadId;
                }

                //是否确认取消并单
                this.$confirm(this.$t('message.cancelCombineConfirm'), this.$t("common.pleaseConfirm"), {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    let cancelHBLIds = "";
                    //过滤掉新增还未保存的分单
                    this.tableHBLInfo.forEach((item) => {
                        if (this.addHBLBillInfoList.length > 0) {
                            this.addHBLBillInfoList.forEach((newHBL) => {
                                if (item.bookingHeadId !== newHBL.bookingHeadId) {
                                    cancelHBLIds = cancelHBLIds + (cancelHBLIds.length > 0 ? "," : "") + item.bookingHeadId;
                                }
                            })
                        } else {
                            cancelHBLIds = cancelHBLIds + (cancelHBLIds.length > 0 ? "," : "") + item.bookingHeadId;
                        }
                    });

                    //调用后端取消并单接口
                    this.axios({
                        method: 'post',
                        url: '/api/spliteCombine/cancelCombine',
                        data: {
                            cancelMBLId: bookingHeadMBLId,
                            cancelHBLIds: cancelHBLIds
                        },
                        headers: {
                            'Accept-language': localStorage.getItem("locale"),
                            'Content-Type': 'application/json'
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            this.combineSearchAction();
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                        //请求成功,查询按钮设置为未点击状态,允许再次请求
                        this.isClick = false;
                    }).catch(error => {
                        //请求失败,查询按钮设置为未点击状态,允许再次请求
                        this.isClick = false;
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                });
                this.isClick = false;
            },
            /**
             * 移除分单
             */
            removeHBLAction() {
                if (this.tableHBLInfo.length > 0) {
                    if (this.isClick) {
                        return;
                    }
                    this.isClick = true;

                    let combineMBLId = "";
                    let isRemove = false;

                    //获取主单
                    if (this.tableBillInfoSelection != null && this.tableBillInfoSelection.length > 0) {
                        combineMBLId = this.tableBillInfoSelection[0].bookingHeadId;
                    }

                    // 校验是否有勾选分单
                    if (this.tableHBLInfoChecked == null || this.tableHBLInfoChecked.length <= 0) {
                        this.$alert(this.$t('message.noSelectedHBL2Delete'), this.$t("common.tips"), {
                            confirmButtonText: this.$t("common.okButton")
                        });
                        return;
                    }

                    //是否移除勾选的分单
                    this.$confirm(this.$t('message.removeCheckedHBLConfirm'), this.$t("common.pleaseConfirm"), {
                        distinguishCancelAndClose: true,
                        confirmButtonText: this.$t("common.deleteButton"),
                        cancelButtonText: this.$t("common.cancelButton")
                    }).then(() => {
                        let removeHBLIds = "";
                        let excludeIds = "";
                        //从勾选的分单中过滤掉新增还未保存的分单
                        this.tableHBLInfoChecked.forEach((itemChecked) => {
                            if (this.addHBLBillInfoList.length > 0) {
                                this.addHBLBillInfoList.forEach((newHBL) => {
                                    if (itemChecked.bookingHeadId !== newHBL.bookingHeadId) {
                                        removeHBLIds = removeHBLIds + (removeHBLIds.length > 0 ? "," : "") + itemChecked.bookingHeadId;
                                    }
                                })
                            } else {
                                removeHBLIds = removeHBLIds + (removeHBLIds.length > 0 ? "," : "") + itemChecked.bookingHeadId;
                            }
                        });

                        //调用后端移除分单接口
                        this.axios({
                            method: 'post',
                            url: '/api/spliteCombine/removeHBL',
                            data: {
                                removeMBLId: combineMBLId,
                                removeHBLIds: removeHBLIds
                            },
                            headers: {
                                'Accept-language': localStorage.getItem("locale"),
                                'Content-Type': 'application/json'
                            }
                        }).then(response => {
                            this.responseCode = response.data.backMessage;
                            if (response.data.backCode === "200") {
                                isRemove = true;
                            } else if (response.data.backCode === "20201") {
                                //部分分单移除失败
                                isRemove = true;
                                excludeIds = response.data.object;
                            } else {
                                this.showMessage(false, this.responseCode, "error");
                            }

                            if (isRemove) {
                                this.tableHBLInfo.forEach((item, index) => {
                                    if (removeHBLIds.indexOf(item.bookingHeadId) >= 0 && excludeIds.indexOf(item.bookingHeadId) < 0) {
                                        this.tableHBLInfo.remove(index);
                                    }
                                })
                            }
                            //请求成功,查询按钮设置为未点击状态,允许再次请求
                            this.isClick = false;
                        }).catch(error => {
                            //请求失败,查询按钮设置为未点击状态,允许再次请求
                            this.isClick = false;
                            if (error.data) {
                                this.responseCode = error.data.backMessage;
                                this.showMessage(false, this.responseCode, "error");
                            } else {
                                this.showMessage(false, error, "error");
                            }
                        });
                    })

                }
            },

            /**
             * 新增分单
             */
            popNewHBLClick(flag) {
                if (this.popTableHBLInfoChecked != null && this.popTableHBLInfoChecked.length > 0) {
                    //获取批量勾选的分单记录
                    if (flag) {
                        //新增分单,清空界面原有数据
                        this.tableBillInfo = [];                 //舱单信息
                        this.tableMasterPreContainerBillInfo = [];  //主单箱信息
                        this.tableHBLInfo = [];                  // 分单信息
                        this.tableHBLPreContainerBillInfo = [];     //分单箱信息
                        //新增选中分单到分单信息表格中
                        this.tableHBLInfo = this.popTableHBLInfoChecked;
                        //默认选中首行分单
                        if (this.tableHBLInfo.length > 0) {
                            this.setTableCurrentRow(2, 0);
                        }
                    } else {
                        //追加选中分单到分单信息表格中
                        this.popTableHBLInfoChecked.forEach((billNew) => {
                            this.tableHBLInfo.push(billNew);
                        });
                        //默认选中最后一行行分单
                        if (this.tableHBLInfo.length > 0) {
                            this.setTableCurrentRow(2, this.tableHBLInfo.length - 1);
                        }
                    }
                    //记录新增但还未保存的分单信息
                    this.popTableHBLInfoChecked.forEach((newHBL) => {
                        this.addHBLBillInfoList.push(newHBL);
                    });
                    //清空分担查询弹框中选中记录集合
                    this.popTableHBLInfoChecked = [];
                    this.HBLInfoDialogVisible = false;
                }
            },
            /**
             * 取消添加分单
             */
            popCancelClick() {
                //清空分单查询弹框中选中记录集合
                this.popTableHBLInfoChecked = [];
                this.HBLInfoDialogVisible = false;
            },
            /**
             * 船名航次VVL弹框 船名/搜索/关闭/确定 按钮点击
             */
            showVesselList() {//船名输入框点击
                this.boatListShow = true;
                this.axios({
                    method: 'get',
                    url: '/api/codedict/getVesselList',
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.boatList = response.data.object;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            closePopoverView() {//关闭按钮点击
                this.$refs.popover.showPopper = false;
            },
            vvlSearch() {//船名航次航段弹框 搜索按钮点击
                if (this.isVVLSearchClick) {
                    return;
                }
                this.isVVLSearchClick = true;
                this.axios({
                    method: 'post',
                    url: '/api/voyagePlan/getVVLEntity',
                    data: {
                        voyageNo: this.search.voyageNo,
                        voyageLeg: this.search.voyageLeg,
                        vesselName: this.search.vesselName,
                        vesselCode: this.search.vesselCode,
                        pageNum: this.popPageNum,
                        pageSize: this.popPageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.popData = response.data.object.list;
                        this.popTotal = response.data.object.total;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    this.isVVLSearchClick = false;
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.isVVLSearchClick = false;
                });
                //每次查询结束清空popVVLTableSelection
                this.popVVLTableSelection = [];
            },
            popConfirm() {//确认按钮点击,赋值选中记录的船名和航次到VVL查询输入框中
                if (this.popVVLTableSelection.length !== 0) {//获取弹框中最后选中的记录
                    this.popRowDblclick(this.popVVLTableSelection[0]);
                }
                this.$refs.popover.showPopper = false;
            },

            /************************************ 分页条 ************************************
             * VVL船名航次弹框数据分页条
             */
            popHandleDemand() {
                this.vvlSearch();
            },
            popHandleSizeChange(val) {
                this.popPageSize = val;
                this.popHandleDemand();
                this.$emit("backTop");
            },
            popHandleCurrentChange(val) {
                this.popPageNum = val;
                this.popHandleDemand();
                this.$emit("backTop");
            },

            /************************************ 行记录点击事件 ************************************
             * 船名航次VVL弹框行记录点击事件:
             *  某行被双击时,自动关闭弹框,获取该行船名航次数据,赋值订舱查询页船名航次输入框
             */
            popRowDblclick(row) {
                this.search.vesselCode = row.vesselCode;
                this.search.voyageNo = row.voyageNo;
                this.search.voyageLeg = row.voyageLeg;
                this.$refs.popover.showPopper = false;
            },
            popRowClick(row) {
                this.popVVLTableSelection = [row];
            },
            /**
             * 主单信息行记录点击事件
             */
            tableBillInfoRowClick(row) {
                this.tableBillInfoSelection = [row];
                this.setTableCurrentRow(0, row.index);
            },
            /**
             * 分单信息行记录点击事件
             */
            tableHBLRowClick(row) {
                this.tableHBLInfoSelection = [row];
                this.setTableCurrentRow(2, row.index);
            },
            /**
             * 选中提单信息行带出箱信息
             */
            setTableCurrentRow(type, index) {
                if (type === 0) {
                    this.tableMasterPreContainerBillInfo = [];
                    //设置主单信息表格当前选中行
                    this.$refs.tableBillInfo.setCurrentRow(this.tableBillInfo[index], true);
                    this.tableBillInfoSelection = [this.tableBillInfo[index]];
                    // 加载选中主单箱信息
                    if (this.tableBillInfoSelection != null && this.tableBillInfoSelection.length > 0) {
                        this.tableMasterPreContainerBillInfo = this.tableBillInfoSelection[0].bkPreContainers;
                        // 加载选中主单的分单信息
                        this.loadHBLInfoInfo(this.tableBillInfoSelection[0]);
                    }
                } else if (type === 2) {
                    this.tableHBLPreContainerBillInfo = [];
                    //设置分单信息表格当前选中行
                    this.$refs.tableHBLInfo.setCurrentRow(this.tableHBLInfo[index], true);
                    this.tableHBLInfoSelection = [this.tableHBLInfo[index]];
                    // 加载选中分单箱信息
                    if (this.tableHBLInfoSelection != null && this.tableHBLInfoSelection.length > 0) {
                        this.tableHBLPreContainerBillInfo = this.tableHBLInfoSelection[0].bkPreContainers;
                    }
                }
            },
            /**
             * 加载分单信息
             */
            loadHBLInfoInfo(billInfo) {
                if (billInfo == null || billInfo.bookingHeadId == "") {
                    return;
                }
                if (billInfo.spliteCombinType != null && billInfo.spliteCombinType == 1
                    && billInfo.mainDetailType != null && billInfo.mainDetailType == 0) {
                    //调用后端并单分单查询API
                    this.axios({
                        method: 'post',
                        url: '/api/spliteCombine/getCombineHBLBillList',
                        data: {
                            bookingHeadId: billInfo.bookingHeadId
                        },
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            let HBLInfo = JSON.parse(response.data.object);
                            this.tableHBLInfo = HBLInfo;
                            //默认选中首行
                            if (this.tableHBLInfo.length > 0) {
                                this.setTableCurrentRow(2, 0);
                            }
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                    }).catch(error => {
                        //请求失败,查询按钮设置为未点击状态,允许再次请求
                        if (error.data) {
                            this.tableHBLInfo = [];
                            this.tableHBLPreContainerBillInfo = [];
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                }
            },

            /************************************ 基础数据下拉框赋值 ************************************/
            checkBoatData(boat) {//pop  【船名】下拉选择
                this.search.vesselCode = boat.vesselCode;
                this.search.vesselName = boat.vesselName;
                this.boatListShow = false
            },
            portFocus() {//【港口】下拉查询
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/port/getAllPortList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.portOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            getCargoTypeName(cargoTypeCode) {
                let cargoTypeName = cargoTypeCode;
                try {
                    if (cargoTypeCode !== "") {
                        if (this.cargoTypeOptions.length <= 0) {
                            this.cargoTypeFocus();
                        }
                        this.cargoTypeOptions.forEach((item) => {
                            if (item.codeValue === cargoTypeCode) {
                                cargoTypeName = item.displayValueCn;
                                throw new Error("EndForEach");
                            }
                        })
                    }
                } catch (error) {
                    if (error.message === "EndForEach") {
                        return cargoTypeName;
                    } else {
                        this.showMessage(false, error, "error");
                    }
                }
            },
            /**
             * 货类
             */
            cargoTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getCargoTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.cargoTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 箱型
             */
            containerTypeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getContainerTypeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.containerTypeOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },

            /************************************ 页面初始化 ************************************
             * 初始化基础数据
             */
            initCombos() {
                this.portFocus();
                this.cargoTypeFocus();
                this.containerTypeFocus();
            },

            /************************************ 接口返回数据国际化显示 *************************************/
            getBookingStatusDisplayValue(item) {
                return localStorage.getItem('locale') == 'en' ? item.bookingStatusDisplay : item.bookingStatusDisplayCn;
            },
            getPolDisplayValue(item) {
                return localStorage.getItem('locale') == 'en' ? item.polName : item.polNameCn;
            },
            getPodDisplayValue(item) {
                return localStorage.getItem('locale') == 'en' ? item.podName : item.podNameCn;
            },
            getDelDisplayValue(item) {
                return localStorage.getItem('locale') == 'en' ? item.delName : item.delNameCn;
            },
        },
        mounted() {
        },
        created() {
            this.initCombos();
            this.$parent.updateHeaderAside();
        },
        activated() {

        }
    };
</script>
<style lang="scss" scoped>
    @import "../../assets/scss/base.scss";
    @import "../../assets/scss/public.scss";

    .jdt_nr {
        width: 50%;
        margin: 0 auto;
        z-index: 10001;
        top: 50%;
        margin-top: -31px;
        text-align: center;
        position: absolute;
        margin-left: 25%
    }

    .inputName {
        flex: 1;
        margin: 0 5px;
    }

    .topMargin {
        margin-top: 20px;
    }

    .searchBtn {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        margin: 0 5px;
    }

    .voyageIcon {
        margin-left: 10px;
        margin-top: 5px;
        width: 30px;
        height: 30px;
        border: 1px solid #0091ff;
        border-radius: 4px;
    }

    .noData {
        height: 100%;
        margin: 15px 0;
        background-color: #ffffff;
    }

    .searchList {
        margin: 15px 0;
    }

    /deep/ .el-input-group__prepend {
        background-color: #d9e3f0;
    }

    .popoverView {
        padding: 5px;
        background-color: #ffffff;
    }

    .popoverInner {
        margin: 5px;
        margin-top: 0;
    }

    .flex1 {
        flex: 1;
    }

    .boatBox {
        position: relative;

        .boatBox-list-box {
            min-width: 280px;
            position: absolute;
            left: 51px;
            top: 30px;
            background: $colorA;
            padding: 5px 10px;
            z-index: 100;
            border: 1px solid $colorE;
            font-size: $fontC;
            font-weight: 600;

            .boatBox-top {
                width: 100%;
                height: 20px;
                line-height: 20px;
                background: $colorB;
            }

            .left {
                width: 30%;
                margin-right: 4%;
            }

            .right {
                width: 66%;
            }

            ul {
                padding: 0;
                margin: 0;

                li {
                    border-bottom: 1px solid #e7f0fc;
                    padding: 4px 2px;
                }

                li:last-of-type {
                    border: none;
                }

                li:hover {
                    background: rgb(224, 240, 245);
                }
            }
        }
    }

    .cardTitle {
        margin-bottom: 10px;
        margin-top: 12px;

        span {
            font-size: $fontE;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }
</style>